import { useSelector } from '@xstate/react';
import { FC, useState } from 'react';

import { TooltipLabel } from '@eluve/blocks';
import { NewButton } from '@eluve/components';

import { useSegmentAudioContext } from './SegmentAudioContextStore';

export interface UtteranceActionsProps {
  utteranceIdx: number;
  utteranceId: string;
  isReadonly: boolean;
  hasHumanUpdatedText: boolean;
  mergeUtterance: (utteranceId: string) => Promise<void>;
  resetUtterance: (utteranceId: string) => Promise<void>;
}

export const UtteranceActions: FC<UtteranceActionsProps> = ({
  utteranceIdx,
  utteranceId,
  isReadonly,
  hasHumanUpdatedText,
  mergeUtterance,
  resetUtterance,
}) => {
  const { store } = useSegmentAudioContext();

  const isFocused = useSelector(
    store,
    (state) => state.context.focusedUtteranceId === utteranceId,
  );
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <NewButton
        onClick={() => {
          setIsLoading(true);
          mergeUtterance(utteranceId).finally(() => setIsLoading(false));
        }}
        type="outline"
        aria-label="Merge Utterance"
        icon={{ name: 'Merge' }}
        size="s"
        disabled={utteranceIdx === 0 || isReadonly || isLoading}
      />
      {isFocused ? (
        <TooltipLabel label="Click 'Close' or exit edit mode to reset this utterance">
          <NewButton
            type="outline"
            aria-label="Reset Utterance"
            icon={{ name: 'RefreshCw' }}
            disabled={true}
            size="s"
          />
        </TooltipLabel>
      ) : (
        <NewButton
          onClick={() => {
            setIsLoading(true);
            resetUtterance(utteranceId).finally(() => setIsLoading(false));
          }}
          type="outline"
          aria-label="Reset Utterance"
          icon={{ name: 'RefreshCw' }}
          disabled={isReadonly || !hasHumanUpdatedText || isLoading}
          size="s"
        />
      )}
    </>
  );
};
